define('app/views/inquiries',['require','./page'],function(require){

  var Page = require('./page');

  return Page.extend({

    view: 'inquiries',

    initialize: function(options){
      Page.prototype.initialize.call(this, options);
      this.model.set('guests', _.range(1, 61));
    }

  });

});
